/* @flow */
import { createStore, applyMiddleware } from 'redux';
import {
  entitiesReducer,
  errorsReducer,
  queriesReducer,
  queryMiddlewareAdvanced,
} from 'redux-query/advanced';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';
import superagent from 'superagent';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTracker } from 'redux-segment';

import apiNetworkInterface from './apiNetworkInterface';
import MockApiInterface from './MockApiInterface';
import tripRequests from './trip-requests';
import fareEstimates from './fare-estimates';
import currentUser from './current-user';

MockApiInterface(superagent);

const getQueries = state => state.queries;
const getEntities = state => state.entities;
const tracker = createTracker();

export const RootReducer = persistCombineReducers(
  { key: 'persist', storage, whitelist: ['currentUser', 'tripRequests'] },
  {
    entities: entitiesReducer,
    errors: errorsReducer,
    queries: queriesReducer,
    tripRequests: tripRequests.reducer,
    fareEstimates: fareEstimates.reducer,
    currentUser: currentUser.reducer,
    form: formReducer,
  }
);

/* eslint-disable no-underscore-dangle */
export const Store = applyMiddleware(
  queryMiddlewareAdvanced(apiNetworkInterface)(getQueries, getEntities),
  thunk,
  tracker
)(createStore)(
  RootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
/* eslint-enable */

export const persistor = persistStore(Store);
/*
export const StoreRehydrated = new Promise(resolve => {
  persistStore(Store, null, () => resolve());
});
*/



// WEBPACK FOOTER //
// ./src/redux/index.js